export enum CustomerModalSubmitActionType {
  Create = 'create',
  Edit = 'edit',
}
